// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__nUNxb","menu":"layout_menu__Od9L_","bottom-sheet":"layout_bottom-sheet__GxD01","content":"layout_content__HTL55"};